const AFF_SUB_5_PARAMS = {
    usource: "utm_source",
    umedium: "utm_medium",
    ucampaign: "utm_campaign",
};
const parseAffSub5 = (affSub5) => affSub5
    .split("|")
    .map((param) => param.split("="))
    .filter((pair) => AFF_SUB_5_PARAMS[pair[0]])
    .map((pair) => `${AFF_SUB_5_PARAMS[pair[0]]}=${pair[1]}`)
    .join("&");
const getPartnerLocationSearch = (url) => ["aff_id", "aff_sub5"]
    .map((param) => {
    const value = url.searchParams.get(param);
    if (value && param === "aff_sub5") {
        return parseAffSub5(value);
    }
    if (value) {
        return `${param}=${url.searchParams.get(param)}`;
    }
    return undefined;
})
    .filter((str) => str)
    .join("&");
const getPartnerLocation = (url) => {
    const search = getPartnerLocationSearch(url);
    return `${url.origin}${url.pathname}${search ? `?${search}` : ""}`;
};
const getWLLocationSearch = (url) => [
    "aff_id",
    "utm_source",
    "utm_medium",
    "utm_campaign",
    "utm_content",
    "utm_term",
]
    .map((param) => url.searchParams.get(param)
    ? `${param}=${url.searchParams.get(param)}`
    : "")
    .filter((str) => str)
    .join("&");
const getWLLocation = (url) => {
    const search = getWLLocationSearch(url);
    return `${url.origin}${url.pathname}${search ? `?${search}` : ""}`;
};
const parseWLUrl = (urlString) => {
    try {
        const url = new URL(urlString);
        return {
            wlLocation: getWLLocation(url),
            partnerLocation: getPartnerLocation(url),
            fullURL: urlString,
        };
    }
    catch (e) {
        console.error(e);
        return undefined;
    }
};

export { parseWLUrl };
//# sourceMappingURL=parseWLUrl.js.map
